import React from 'react';

const PILLARS = [
  {
    icon: '🛣️',
    title: 'Ausfahrten',
    text: 'Kurvige Strecken, gute Pausen, kein Zeitdruck. Wer mitfährt, kommt entspannt an - nicht als Erster.',
  },
  {
    icon: '🔧',
    title: 'Schrauben & Helfen',
    text: 'Vom Ölwechsel bis zum Fahrwerk: In der Gruppe findet sich für fast jedes Problem jemand, der es schon mal hatte.',
  },
  {
    icon: '☕',
    title: 'Treffen',
    text: 'Stammtische und Sommertreffen. Motorhauben auf, Kaffee in der Hand, Geschichten dazu.',
  },
  {
    icon: '🤝',
    title: 'Miteinander',
    text: 'Egal ob Erstwagen oder Sammlerstück, Classic oder aktuelles Modell - hier zählt die Begeisterung, nicht das Budget.',
  },
];

/**
 * Was der Mitgliederbereich bietet.
 *
 * Bewusst eine Liste und keine fünfte Säule: `.mt-grid` stellt bei 1280px
 * vier Spalten - eine fünfte Karte stünde als Waise in der zweiten Zeile.
 *
 * ⚠️ Hier steht ausschliesslich, was es WIRKLICH schon gibt. Eine Startseite,
 * die etwas verspricht, das hinter der Anmeldung fehlt, verliert genau die
 * Leute, die man gerade gewonnen hat.
 */
const FEATURES = [
  {
    title: 'Termine und Zusagen',
    text: 'Alle Ausfahrten und Treffen an einer Stelle. Du sagst zu oder ab, siehst wer sonst noch kommt, und holst dir den Termin in deinen eigenen Kalender.',
  },
  {
    title: 'Wer ist in deiner Nähe?',
    text: 'Eine Karte mit den Regionen der Mitglieder. Dazu ein Umkreis-Regler an der Terminliste - so siehst du nur, was für dich erreichbar ist.',
  },
  {
    title: 'Vernetzen',
    text: 'Trag ein, worüber du gern sprichst - schrauben, Touren planen, oder auch Bowling. Die Seite zeigt dir, wer dieselben Themen angegeben hat. Ob und wie du erreichbar bist, entscheidest du selbst.',
  },
  {
    title: 'Stammtische',
    text: 'Feste Runden mit eigenem Treffpunkt und Rhythmus, jede mit eigener Seite. Wer eine in seiner Ecke aufmachen will, bekommt das Werkzeug dafür.',
  },
  {
    title: 'Deine Fahrzeuge',
    text: 'Bis zu drei MINIs mit Bildern, Eckdaten und ihrer Geschichte. Dazu das MINI Bingo: neun Fotoaufgaben, vom Waschtag bis zur Rennstrecke.',
  },
  {
    title: 'Galerie und Rückfragen',
    text: 'Fotos der vergangenen Treffen in Alben - und an jedem Termin ein Platz für Rückfragen, damit Treffpunkt und Mitfahrgelegenheit nicht im Chat untergehen.',
  },
];

export default function About() {
  return (
    <section className="mt-section mt-section--alt" id="über-uns">
      <div className="mt-container">
        <div className="mt-head mt-head--center">
          <span className="mt-kicker">Wer wir sind</span>
          <h2>Ein bunter Haufen von Mini-Verrückten</h2>
          <p className="mt-lead">
            Was 2022 als spontane Ausfahrt in Bonn/Sieg anfing, ist inzwischen ein fester Kreis
            mit eigenen Terminen - und wächst über die Region hinaus: Wer in seiner Ecke eine
            Ausfahrt plant, bringt den Club dorthin.
          </p>
          <p className="mt-lead">
            Uns gibt es inzwischen <strong>deutschlandweit</strong>. Der Club ist der Ort, an
            dem MINI-Begeisterte miteinander in Kontakt kommen - über die eigene Stadt hinaus,
            aber ohne dass daraus ein anonymer Verteiler wird. Du findest Leute in deiner Nähe,
            verabredest dich zur nächsten Ausfahrt und fragst nach, wenn am Auto etwas klemmt.
          </p>
        </div>

        <div className="mt-grid">
          {PILLARS.map((pillar) => (
            <article key={pillar.title} className="mt-card mt-pillar">
              <span className="mt-pillar__icon" aria-hidden="true">
                {pillar.icon}
              </span>
              <h3>{pillar.title}</h3>
              <p>{pillar.text}</p>
            </article>
          ))}
        </div>

        <div className="mt-about__more">
          <h3>Und was bietet die Seite?</h3>
          <p className="mt-muted">
            Der Mitgliederbereich ist mehr als eine Terminliste. Er ist kostenlos und gehört
            zum Club - hier steckt nichts hinter einer Bezahlschranke.
          </p>
          <ul className="mt-about__features">
            {FEATURES.map((f) => (
              <li key={f.title}>
                <strong>{f.title}</strong>
                <span>{f.text}</span>
              </li>
            ))}
          </ul>
        </div>
      </div>
    </section>
  );
}
